
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent/[sid]",
      function () {
        return require("private-next-pages/agent/[sid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent/[sid]"])
      });
    }
  